import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild, AfterViewInit, HostListener, ElementRef } from '@angular/core';
import { FormArray, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { BaseComponent } from '../base-component';
import { FileDialogComponent } from '../file-dialog/file-dialog.component';
import { AFConsent, AFNavigation, Attachment, OusCountryAttachmentType } from '../model/af.model';
import { ConsentService } from '../service/consent.service';
import { EventService } from '../service/event.service';
import { AttachmentUploadedEvent, ValidateAndNavigateEvent, ChangeNavigationEvent, ProgressBarEvent, ClientErrorEvent, SubmitApplicantEvent, FormSubmittedEvent, SkipToMainContentEvent } from '../service/events';
import { Subscription } from 'rxjs';
import { AuthService } from '../service/auth.service';
import { SubmitDialogComponent } from '../submit-dialog/submit-dialog.component';
import { CustomValidatorsService } from '../service/custom-validators.service';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';
import { ValidHelpLinkDialogComponent } from './valid-help-link-dialog/valid-help-link-dialog.component';
import Bowser from 'bowser';

@Component({
  selector: 'app-certification',
  templateUrl: './certification.component.html',
  styleUrls: ['./certification.component.scss'],
  standalone: false
})
export class CertificationComponent extends BaseComponent implements OnInit, OnDestroy, AfterViewInit {

  consentData: AFConsent;
  consentGroup: UntypedFormGroup;
  consentInstruction: string;
  consentCheckInstruction: string;
  date: any;
  legalRequirementCheckDate: any;
  signatureImg: string; // @Input wet-signature
  isMinor: boolean = false;
  showOusAttachments: boolean = false;
  subcription: Subscription;
  submitSubcription: Subscription;
  formSubmitted: boolean = false;
  check: boolean = false;
  checkTwo: boolean = false;
  sigCheckValue: boolean = false;
  consentChange: boolean = false;
  border: boolean = false;
  displayedColumns: string[] = ['fileName', 'descOfFileName', 'fileType', 'fileSize', 'attachedBy', 'attachedDateString', 'remove'];
  displayedOusColumns: string[] = ['attachmentName', 'downloadble', 'attachmentId'];
  dataSource = new MatTableDataSource<Attachment>();
  ousDataSource = new MatTableDataSource<OusCountryAttachmentType>();
  skinnyFlag: boolean = false;

  constructor(private readonly eventBus: EventService, private readonly userService: AuthService, private readonly consentService: ConsentService, private readonly fb: UntypedFormBuilder,
    private readonly _router: Router, private readonly datepipe: DatePipe, private readonly dialog: MatDialog, private readonly _snackBar: MatSnackBar, private readonly customValidator: CustomValidatorsService,
    public dialogRef: MatDialogRef<ErrorDialogComponent>, private readonly validHelpLinkDialog: ValidHelpLinkDialogComponent) {
    super(eventBus, _router);
  }

  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  @ViewChild("addElement") addElement: ElementRef;

  ngOnInit() {
    this.createGroup();
    this.subscribeEvents();
  }

  get submit() { return this.consentGroup.get('submit') }
  get output() { return this.consentGroup.get('output') }
  get certificationCheck() { return this.consentGroup.get('certificationCheck') }
  get certificationCheckDate() { return this.consentGroup.get('certificationCheckDate') }
  get consentLegalRequirementsMet() { return this.consentGroup.get('consentLegalRequirementsMet') }
  get consentLegalRequirementCheckDate() { return this.consentGroup.get('consentLegalRequirementCheckDate') }
  get consentApplicantSignedName() { return this.consentGroup.get('consentApplicantSignedName') }
  get verifyId() { return this.consentGroup.get('verifyId') }
  get bookmarkUrl() { return this.consentGroup.get('bookmarkUrl') }


  ngAfterViewInit() {
    this.handleZoom();
    this.consentGroup.valueChanges.subscribe(() => {
      setTimeout(() => {
        let progress = this.getPercentage(this.consentGroup);
        this.eventBus.emit(new ProgressBarEvent({ id: progress }));
      }, 100);
    });

    this.consentLegalRequirementsMet.valueChanges.subscribe(() => {
      this.onChangeConsentLegalRequirementsMet();
    });

    this.certificationCheck.valueChanges.subscribe(() => {
      this.onChangecertificationCheck();
    });

    // retain navigation on page refresh
    let navlink = this.userService.getNavLinks().find(e => e.routerLink === "/certification");
    this.eventBus.emit(new ChangeNavigationEvent({ id: navlink.id }));
  }

  getPercentage(container: UntypedFormGroup): number {
    let errorCount = 0;
    let totalCount = 0;

    for (let controlKey in container.controls) {

      if (container.controls.hasOwnProperty(controlKey)) {
        if (container.controls[controlKey].validator != null) {
          totalCount += container.controls[controlKey].validator.length;
        }
        if (container.controls[controlKey].errors) {
          errorCount += Object.keys(container.controls[controlKey].errors).length;
        }
      }
    }

    for (let ousAttachmentType of this.ousDataSource.data) {
      totalCount += 1;
      if (!ousAttachmentType.attachmentCheck) {
        errorCount += 1;
      }
    }

    return ((totalCount - errorCount) / totalCount) * 100;
  }

  createGroup() {
    this.consentGroup = this.fb.group({
      verifyId: [this.userService.getVerifyId()],
      certificationCheck: [false, Validators.requiredTrue],
      output: ['', Validators.required],
      consentLegalRequirementsMet: [false, Validators.requiredTrue],
      certificationCheckDate: [''],
      consentApplicantSignedName: ['', [Validators.required, this.customValidator.validateRequiredField]],
      consentLegalRequirementCheckDate: [''],
      bookmarkUrl: [''],
      submit: [false],
      browserName: [''],
      browserVersion: ['']
    });
  }

  getUrl(sig: string) {
    this.signatureImg = sig; // Gets the base64 String from wet-signature @Output
    this.output.setValue(sig);
  }

  sigCheck(sigCheck: boolean) {
    this.sigCheckValue = sigCheck;
  }

  subscribeEvents() {
    this.consentService.getConsent().subscribe({
      next: (data: AFConsent) => {
        this.consentData = data;
        this.skinnyFlag = data.skinnyFlag === '1';
        this.consentGroup.patchValue(this.consentData);
        this.getBrowserInformation();

        if (this.consentData.lockBoxFlag == '-1') {
          this.consentInstruction = data.certificationLanguageLookup['CERTIFICATION_CONTENT_DEFAULT'];
        } else {
          this.consentInstruction = data.certificationLanguageLookup['CERTIFICATION_CONTENT_LOCKBOX'];
        }

        this.consentCheckInstruction = data.languageLookup['CERTIFICATION_2'];
        this.date = this.consentData.certificationCheckDate;
        this.isMinor = (this.consentData.isMinor == "0");
        this.legalRequirementCheckDate = this.consentData.consentLegalRequirementCheckDate;
        this.signatureImg = this.output.value;

        if (this.consentData.attachmentList != null) {
          this.dataSource.data = this.consentData.attachmentList;
        }

        if (this.consentData.ousAttachmentList != null) {
          this.ousDataSource.data = this.consentData.ousAttachmentList;
        }

        this.showOusAttachments = (this.consentData.ousQuestionEligible == '1' &&
          this.consentData.ousMilitaryCheck == '1' && this.consentData.haveYouLivedOUS == '1') || (null != this.userService.getRequireOutsideJobCountryDocument() && this.userService.getRequireOutsideJobCountryDocument().trim().length > 0);
      },
      error: (error: Error) => {
        console.log(error);
      }
    });

    this.subcription = this.eventBus.on(
      ValidateAndNavigateEvent,
      (event): void => {
        if (event.payload.currentLink === '/certification') {
          this.submit.setValue(false);
          this.bookmarkUrl.setValue("");
          if (event.payload.save) {
            this.saveApplicantForm((this.consentGroup.value), event);
          } else if (event.payload.saveAndFinishLater) {
            this.bookmarkUrl.setValue(event.payload.currentLink);
            this.saveApplicantForm((this.consentGroup.value), event);
          } else if (this.validate()) {
            if (this.showOusAttachments) {
              for (let ousAttachmentType of this.ousDataSource.data) {
                if (!ousAttachmentType.attachmentCheck) {
                  this.eventBus.emit(new ClientErrorEvent({ text: "Please complete and upload all required documents prior to submitting your Background Check Form." }));
                  setTimeout(() => {
                    this.addElement.nativeElement.focus();
                    this.border = true;
                  });
                  return;
                }
              }
            }

            if (this.isMinor) {
              let attachment = this.dataSource.data.find(item => item.descOfFileName == 'Under 18 Consent Form');
              if (!attachment) {
                this.eventBus.emit(new ClientErrorEvent({ text: "You must attach a file with the File Description 'Under 18 Consent Form' to proceed. You can download the form by clicking the link in the instructions." }));
                return;
              }
            }

            const dialogRef = this.dialog.open(SubmitDialogComponent, {
              width: '550px',
              role: 'alertdialog'
            });
            dialogRef.afterClosed().subscribe(() => {
            });

          }
        }
      }
    );

    this.sub = this.eventBus.on(
      AttachmentUploadedEvent,
      (event): void => {
        if (event.payload.file) {
          let attachment = event.payload.file as Attachment;
          this.dataSource.data.push(attachment);
          this.dataSource._updateChangeSubscription();

          if (event.payload.file.typeOfAttachmentId) {
            this.ousDataSource.data.find(item => item.attachmentId == event.payload.file.typeOfAttachmentId).attachmentCheck = true;
            this.ousDataSource._updateChangeSubscription();
            setTimeout(() => {
              let progress = this.getPercentage(this.consentGroup);
              this.eventBus.emit(new ProgressBarEvent({ id: progress }));
            }, 100);
          }
        }
      }
    );

    this.submitSubcription = this.eventBus.on(
      SubmitApplicantEvent,
      (event): void => {
        this.saveApplicantForm((this.consentGroup.value), event);
      }
    );

    this.eventBus.on(
      FormSubmittedEvent,
      (event): void => {
        if (event.payload.text) {
          this.formSubmitted = (event.payload.text == "1");
        }
      }
    );

    this.eventBus.on(
      SkipToMainContentEvent,
      (event): void => {
        if (event.payload.text && event.payload.text == "/certification") {
          let mainContentElement = document.querySelector("#main-content"); //check if main-content id exists on page
          if (mainContentElement) {
            mainContentElement.scrollIntoView(true);
          }
        }
      }
    );
  }

  getBrowserInformation(): void {
    const uaData = (navigator as any).userAgentData;
    let cleanUA = navigator.userAgent.match(/[\x20-\x7E]+/g)?.join('') ?? '';
    cleanUA = cleanUA.length > 255 ? cleanUA.substring(0, 255) : cleanUA;

    if (uaData?.brands) {
      const brands = uaData.brands.map((b: any) => `${b.brand} ${b.version}`).join(', ');
      let brand = brands;

      if (uaData?.mobile !== undefined) {
        brand += ", Device: " + (uaData.mobile ? "Mobile" : "Desktop");
      }

      this.consentGroup.get("browserName").setValue(brand);
      this.consentGroup.get("browserVersion").setValue(cleanUA);
    } else {
      // Fallback for browsers that do not support userAgentData
      const parsed = Bowser.getParser(cleanUA);
      const browser = parsed.getBrowser();
      const version = browser.version ?? 'Unknown Version';
      this.consentGroup.get("browserName").setValue(browser.name ?? 'Unknown Browser');
      this.consentGroup.get("browserVersion").setValue(version + ", Type: " + parsed.getPlatformType());
    }
  }

  @HostListener('window:resize', ['$event'])
  @HostListener('window:load', ['$event'])
  handleZoom() {
    const windowWidth = window.innerWidth;
    if (windowWidth <= 585) {
      this.consentChange = true;
    } else {
      this.consentChange = false;
    }
  }

  @HostListener('document:keydown', ['$event'])
  clearBorder(keyDown: KeyboardEvent) {
    if (keyDown.key === 'Tab') {
      this.border = false;
    }
  }

  @HostListener('click', ['$event'])
  clearBorderClick() {
    this.border = false;
  }

  onFocusOutMainContent(event) {
    this.eventBus.emit(new SkipToMainContentEvent({ text: "FocusOff" }));
  }

  consentOnBlur() {
    if (this.certificationCheck.value) {
      this.check = false;
    } else {
      this.check = true;
    }
  }

  consentOnFocus() {
    this.check = false;
  }

  legalOnBlur() {
    if (this.consentLegalRequirementsMet.value) {
      this.checkTwo = false;
    } else {
      this.checkTwo = true;
    }
  }

  legalOnFocus() {
    this.checkTwo = false;
  }

  removeAttachment(attachmentId, typeOfAttachmentId) {
    this.consentService.removeAttachment(attachmentId).subscribe({
      next: () => {
        this._snackBar.open("Attachment removed successfully", "Close", {
          duration: 4000,
        });

        this.dataSource.data = this.dataSource.data.filter((value, key) => {
          if (value.mongoAttachmentId) {
            return value.mongoAttachmentId != attachmentId;
          } else {
            return value.attachmentId != attachmentId;
          }
        });

        this.dataSource._updateChangeSubscription();

        let ousAttachment: OusCountryAttachmentType = this.ousDataSource.data.find(item => item.attachmentId == typeOfAttachmentId);
        if (ousAttachment) {
          ousAttachment.attachmentCheck = false;
          this.ousDataSource._updateChangeSubscription();
        }
        setTimeout(() => {
          let progress = this.getPercentage(this.consentGroup);
          this.eventBus.emit(new ProgressBarEvent({ id: progress }));
        }, 100);

      },
      error: (error: any) => console.log(error)
    });
  }

  openFileDialog(ousAttachments, ousAttachmentId) {
    const dialogRef = this.dialog.open(FileDialogComponent, {
      width: '550px',
      role: 'alertdialog',
      data: {
        fileDescriptionLookup: this.consentData.fileDescriptionLookup,
        ousAttachments: ousAttachments,
        ousAttachmentId: ousAttachmentId,
        ousAttachmentDesc: "certification"
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      if (ousAttachments) {
        setTimeout(() => {
          this.addElement.nativeElement.focus();
        });
      }
    });
  }

  onChangecertificationCheck() {
    if (this.certificationCheck.value) {
      if (!this.date) {
        if (!this.consentData.certificationCheckDate) {
          this.date = this.datepipe.transform(new Date(), 'MM/dd/yyyy HH:mm:ss');
        }
      }
    } else if (!this.consentData.certificationCheckDate) {
      this.date = null;
    }
    this.certificationCheckDate.setValue(this.date);
  }

  onChangeConsentLegalRequirementsMet() {
    if (this.consentLegalRequirementsMet.value) {
      if (!this.legalRequirementCheckDate) {
        if (!this.consentData.consentLegalRequirementCheckDate) {
          this.legalRequirementCheckDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy HH:mm:ss');
        }
      }
    } else if (!this.consentData.consentLegalRequirementCheckDate) {
      this.legalRequirementCheckDate = null;
    }
    this.consentLegalRequirementCheckDate.setValue(this.legalRequirementCheckDate);
  }

  saveApplicantForm(consentHistory, event) {
    this.consentService.saveApplicantForm(consentHistory).subscribe({
      next: (data) => {
        if (event.payload.save) {
          this._snackBar.open("Saved successfully", "Close", {
            duration: 4000,
          });
        } else if (event.payload.saveAndFinishLater) {
          this._snackBar.open("Saved successfully", "Close", {
            duration: 4000,
          });
          this._router.navigate(['sessionTimedOut']);
        } else if (data?.showAuthPage) {
          let nav: AFNavigation = this.userService.getNavLinks().find(e => e.routerLink === data.url);
          if (nav) {
            const dialogMsg = "Please complete  all required consent prior to submitting your Background Check Form.";

            this.dialogRef = this.dialog.open(ErrorDialogComponent, {
              ariaLabel: 'Country Mismatch Dialog',
              role: 'alertdialog',
              autoFocus: false,
              disableClose: true,
              width: '550px',
              data: {
                dialogData: dialogMsg
              }
            });

            this.dialogRef.afterClosed().subscribe(() => {
              this.eventBus.emit(new ChangeNavigationEvent({ id: nav.id }));
              this._router.navigateByUrl(nav.routerLink);
            });
          }

        }
      },
      error: (error: any) => console.log(error)
    });
  }

  validate() {
    this.submit.setValue(true);
    this.consentGroup.markAllAsTouched();
    this.check = true;
    this.checkTwo = true;

    if (!this.output.value) {
      this.output.setErrors({ invalid: true });
    }
    if (this.consentGroup?.invalid) {
      let isInvalid = true;
      const firstInvalidField = Object.keys(this.consentGroup.controls).find(field => this.consentGroup.get(field)?.invalid);
      if (this.consentGroup.controls[firstInvalidField] instanceof FormArray) {
        (this.consentGroup.controls[firstInvalidField]).controls.forEach((data: FormGroup) => {
          if (data.invalid && isInvalid) {
            this.userService.setFocus(data);
            isInvalid = false;
          }
        })
      } else {
        this.userService.setFocus(this.consentGroup);
      }
    }

    return !this.consentGroup.invalid;
  }

  loadDocumentHelp(): void {
    this.validHelpLinkDialog.openDialog();
  }

  downloadAttachment(attachmentId: string, fileName: string): void {
    this.userService.downloadAttachment(attachmentId, fileName).subscribe();
  }  

  ngOnDestroy(): void {
    this.subcription.unsubscribe();
    this.sub.unsubscribe();
    this.submitSubcription.unsubscribe();
  }
}
